import styled from 'styled-components/macro';
import { colors, baseSpacing } from 'css/constants';

const FormLabel = styled.label`
  color: ${({ disabled, error }) => {
    if (disabled) {
      return colors.midGrey;
    }
    if (error) {
      return colors.red;
    }
    return '';
  }};
  margin-bottom: 0.5rem;
`;

export const InputLabel = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: ${baseSpacing / 3}px;
  width: fit-content;
`;

export default FormLabel;
